const urlSerialize = (obj, prefix) => {
  const str = [];
  let p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      const k = prefix ? `${prefix}[]` : p;
      const v = obj[p];

      if (v !== null && typeof v === 'object') {
        if (v.length > 0) {
          str.push(urlSerialize(v, k));
        }
      } else {
        str.push(`${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
      }
    }
  }
  return str.join('&');
};

export default urlSerialize;
